<template>
  <div class="h5 c-gray70 m-b-3" selenium="job-request-section-heading">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'job-request-section-heading',
};
</script>
